export default function Footer() {
    return (
        <footer data-testid="footer" className="relative bg-ink border-t border-ink-muted text-cream">
            <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-12">
                <div className="grid md:grid-cols-12 gap-8">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3 mb-4">
                            <span className="w-7 h-7 border border-gold/70 flex items-center justify-center rotate-45">
                                <span className="w-1.5 h-1.5 bg-gold" />
                            </span>
                            <span className="font-serif text-xl tracking-tight">
                                Quick<span className="text-gold">Fin</span>
                            </span>
                        </div>
                        <p className="text-cream/70 font-light max-w-md leading-relaxed text-sm">
                            Private credit, enterprise capital, mortgage architecture and venture conviction — discreetly orchestrated from the Dubai International Financial Centre since 2014.
                        </p>
                    </div>

                    <div className="md:col-span-2">
                        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold mb-4">
                            Mandates
                        </div>
                        <ul className="space-y-2 font-light text-cream/70 text-sm">
                            <li><a href="#services" className="hover:text-gold transition-colors">Private Credit</a></li>
                            <li><a href="#services" className="hover:text-gold transition-colors">Enterprise</a></li>
                            <li><a href="#services" className="hover:text-gold transition-colors">Mortgage</a></li>
                            <li><a href="#services" className="hover:text-gold transition-colors">Venture</a></li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-forest mb-4">
                            House
                        </div>
                        <ul className="space-y-2 font-light text-cream/70 text-sm">
                            <li><a href="#why" className="hover:text-forest transition-colors">Our Standard</a></li>
                            <li><a href="#process" className="hover:text-forest transition-colors">Process</a></li>
                            <li><a href="#stories" className="hover:text-forest transition-colors">Stories</a></li>
                            <li><a href="#faq" className="hover:text-forest transition-colors">Enquiries</a></li>
                        </ul>
                    </div>

                </div>

                <div className="mt-10 pt-6 border-t border-cream-deep flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
                    <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-cream/70">
                        © 2019 QuickFin
                    </div>
                    <div className="flex gap-5 font-mono text-[10px] uppercase tracking-[0.25em] text-cream/70">
                        <a href="#" className="hover:text-gold transition-colors">Discretion</a>
                        <a href="#" className="hover:text-forest transition-colors">Terms</a>
                        <a href="#" className="hover:text-coral transition-colors">Cookies</a>
                    </div>
                </div>
            </div>

            <div className="overflow-hidden">
                <div className="font-serif text-[18vw] leading-none text-gold/[0.1] text-center -mt-6 pb-2 select-none pointer-events-none">
                    QUICKFIN
                </div>
            </div>
        </footer>
    );
}
